<template>
  <div class="bg-image-plan relative">
    <AddPayment :addPaymentShow="showPayment"   @closeAddPayment="showPayment = false" />
    <PaymentAddedSubscribe :showCheckout="showCheckOut" @changePaymentMethod="showPayment = true ; showCheckOut = false"  @closePaymentAddedDialog="showCheckOut = false" />
    <v-btn dark icon class="!absolute sm:!left-10 left-5 top-16" color="#ae8c39" @click="$router.go(-1)" outlined rounded>
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <div fluid p-0 class="h-screen overflow-auto  container">
      <v-row no-gutters class="justify-center align-center  flex-col mb-10">
        <div class="flex justify-center">
          <v-avatar tile height="100" width="150" class=" my-2">
            <img class="" :src="require('@/assets/img/Logo/logo.gif')" />
          </v-avatar>
        </div>
        <v-card-title
          class="!text-center xs:!text-4xl !text-3xl justify-center  for-bg !font-bold font-Handel !uppercase !tracking-wider">
          Pricing Plans
        </v-card-title>
      </v-row>

      <v-row no-gutters :class="`justify-center align-center !gap-16 !relative  `">
        <LoadingSpinner v-if="loading" :class="`!bg-transparent h-[50vh]`" />
        <v-col v-for="(planData, index) in plansData" :key="plansData.id" class="!max-w-fit">
          <PlanCard :planData="planData" @addPaymentModalShow="addPaymentMethodHandler(planData)" />
        </v-col>
      </v-row>

      <!-- <SubscriptionCanellationDialog v-if='selectedPlan' @closeDialog="subscriptionConfirmDialog = false"
        @confirmDialog="subscriptionConfirmDialog = false" :showModal="subscriptionConfirmDialog"
        title="Subscription Confirmation"
        :text="`Are you sure you want to subscribe to our ${selectedPlan.name} subscription plan for $${selectedPlan.amount} per month? This plan will give you access to our ${selectedPlan.name} features and services.`" /> -->
    </div>
  </div>
</template>
<script>
import PlanCard from "@/components/PlanCard.vue";
import AddPayment from "@/components/settings/payement_details/AddPayment.vue";
import axios from "axios";
import LoadingSpinner from "../straight/childs/LoadingSpinner.vue";
import SubscriptionCanellationDialog from "@/components/settings/subscription_details/SubscriptionCanellationDialog.vue";
import PaymentAddedSubscribe from "@/components/settings/payement_details/PaymentAddedSubscribe.vue";
export default {
  data() {
    return {
      showPayment: false,
      showCheckOut: false,
      plansData: [],
      loading: false,
      subscriptionConfirmDialog: false,
      selectedPlanChange : {}
    };
  },
  computed: {
    selectedPlan() {
      return this.$store.getselectedPackageId
    }
  },
  components: { PlanCard, AddPayment, LoadingSpinner, SubscriptionCanellationDialog, PaymentAddedSubscribe },
  methods: {
    addPaymentMethodHandler(plan) {
      this.selectedPlanChange = plan
      if(this.$store.getters.StateUser.data.pm_cardholder_name){
        this.showCheckOut = true;
      }else{
        this.showPayment = true; 
      }


    },
    async getPlans() {
      try {
        this.loading = true;
        const { data } = await axios.get('stripe/plans')
        console.log(data)
        this.plansData = data.plans;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.getPlans()
  },
};
</script>
<style scoped>
.for-bg {
  background: linear-gradient(2deg,
      rgba(157, 115, 31, 1) 34%,
      rgba(171, 130, 49, 1) 40%,
      rgba(188, 149, 72, 1) 46%,
      rgba(219, 182, 112, 1) 50%,
      rgba(192, 153, 76, 1) 54%,
      rgba(175, 134, 54, 1) 61%,
      rgba(157, 115, 31, 1) 72%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
}

.bg-image-plan {
  background: linear-gradient(180deg,
      rgb(0 0 0) 0%,
      rgba(0, 0, 0, 0.5074404761904762) 100%),
    url(../../../assets/images/plan-bg.jpeg);
  background-position: center;
  background-size: cover;
}
</style>
